module.exports = __webpack_public_path__ + "6fd380a21b87ea7172695e76efb79c0e.fbx";